<script>
export default {
  name: 'BtnGooglePay',
};
</script>

<template>
  <svg
    width="179"
    height="54"
    viewBox="0 0 179 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1351_4609)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M171.899 53.067H7.0948C3.46013 53.067 0.5 50.1166 0.5 46.5231V7.25972C0.5 3.65323 3.46013 0.71582 7.0948 0.71582H171.899C175.531 0.71582 178.494 3.65323 178.494 7.25972V46.5231C178.494 50.1166 175.531 53.067 171.899 53.067Z"
        fill="#131313"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M171.899 1.7635C174.948 1.7635 177.443 4.23419 177.443 7.25972V46.5231C177.443 49.5487 174.964 52.0194 171.899 52.0194H7.0948C4.04626 52.0194 1.55111 49.5487 1.55111 46.5231V7.25972C1.55111 4.23419 4.02989 1.7635 7.0948 1.7635H171.899ZM171.899 0.71582H7.0948C3.46013 0.71582 0.5 3.66629 0.5 7.25972V46.5231C0.5 50.1296 3.46013 53.067 7.0948 53.067H171.899C175.531 53.067 178.494 50.1296 178.494 46.5231V7.25972C178.494 3.66629 175.531 0.71582 171.899 0.71582Z"
        fill="#6C6C6C"
      />
      <path
        d="M94.268 18.0333C93.0793 18.0333 92.0773 17.6188 91.2849 16.8029C90.4991 16.0098 90.0603 14.9164 90.0799 13.8002C90.0799 12.6089 90.486 11.6004 91.2849 10.8008C92.0741 9.98481 93.0761 9.57031 94.2647 9.57031C95.4402 9.57031 96.4422 9.98481 97.2477 10.8008C98.0467 11.6265 98.4527 12.635 98.4527 13.8002C98.4396 14.9947 98.0336 16.0032 97.2477 16.7996C96.4586 17.6221 95.4566 18.0333 94.268 18.0333ZM58.9005 18.0333C57.7381 18.0333 56.7296 17.6254 55.9044 16.8192C55.0858 16.0163 54.6699 15.0013 54.6699 13.8035C54.6699 12.6056 55.0858 11.5906 55.9044 10.7877C56.7132 9.98155 57.7217 9.57358 58.9005 9.57358C59.4768 9.57358 60.0368 9.68781 60.5738 9.91954C61.101 10.1447 61.5299 10.4515 61.8475 10.8269L61.9261 10.9215L61.0387 11.7897L60.9471 11.682C60.4461 11.088 59.7748 10.7975 58.8874 10.7975C58.095 10.7975 57.4041 11.0782 56.8343 11.633C56.2613 12.1911 55.9699 12.9222 55.9699 13.8067C55.9699 14.6912 56.2613 15.4223 56.8343 15.9804C57.4041 16.5352 58.095 16.8159 58.8874 16.8159C59.7322 16.8159 60.4428 16.5352 60.9962 15.9804C61.3236 15.654 61.5266 15.1971 61.5987 14.6194H58.7532V13.3987H62.82L62.8364 13.5097C62.8659 13.7153 62.8954 13.9275 62.8954 14.1233C62.8954 15.2493 62.5548 16.1599 61.8803 16.8322C61.1141 17.6286 60.1121 18.0333 58.9005 18.0333ZM105.925 17.8603H104.671L100.83 11.7342L100.863 12.8374V17.8571H99.6086V9.74656H101.04L101.079 9.80857L104.691 15.579L104.658 14.4791V9.74656H105.925V17.8603ZM84.8441 17.8603H83.5736V10.9672H81.3699V9.74656H87.0445V10.9672H84.8408V17.8603H84.8441ZM80.3351 17.8603H79.0679V9.74656H80.3351V17.8603ZM73.2132 17.8603H71.946V10.9672H69.7423V9.74656H75.4169V10.9672H73.2132V17.8603ZM68.94 17.8473H64.0807V9.74656H68.94V10.9672H65.3512V13.1931H68.5896V14.4007H65.3512V16.6266H68.94V17.8473ZM92.2149 15.9641C92.7814 16.5287 93.469 16.8127 94.268 16.8127C95.0899 16.8127 95.7611 16.5352 96.321 15.9641C96.8777 15.4092 97.1593 14.6814 97.1593 13.8035C97.1593 12.9255 96.8777 12.1944 96.3243 11.6428C95.7578 11.0782 95.0669 10.7942 94.2712 10.7942C93.4493 10.7942 92.7781 11.0717 92.2214 11.6428C91.6648 12.1977 91.3832 12.9255 91.3832 13.8035C91.3832 14.6814 91.6615 15.4125 92.2149 15.9641Z"
        fill="#FAFAFA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M89.9622 29.1894C86.8678 29.1894 84.3595 31.5296 84.3595 34.7575C84.3595 37.956 86.8841 40.3255 89.9622 40.3255C93.0565 40.3255 95.5648 37.969 95.5648 34.7575C95.5648 31.5296 93.0565 29.1894 89.9622 29.1894ZM89.9622 38.1192C88.2692 38.1192 86.8121 36.7223 86.8121 34.7444C86.8121 32.7372 88.2725 31.3696 89.9622 31.3696C91.6551 31.3696 93.1122 32.7372 93.1122 34.7444C93.1155 36.7353 91.6551 38.1192 89.9622 38.1192ZM77.7385 29.1894C74.6441 29.1894 72.1359 31.5296 72.1359 34.7575C72.1359 37.956 74.6605 40.3255 77.7385 40.3255C80.8329 40.3255 83.3411 37.969 83.3411 34.7575C83.3411 31.5296 80.8296 29.1894 77.7385 29.1894ZM77.7385 38.1192C76.0456 38.1192 74.5884 36.7223 74.5884 34.7444C74.5884 32.7372 76.0489 31.3696 77.7385 31.3696C79.4314 31.3696 80.8886 32.7372 80.8886 34.7444C80.8886 36.7353 79.4314 38.1192 77.7385 38.1192ZM63.1932 30.8899V33.2463H68.8679C68.6944 34.5682 68.2556 35.544 67.5843 36.2131C66.7526 37.0421 65.469 37.9429 63.2063 37.9429C59.719 37.9429 56.9914 35.1361 56.9914 31.6601C56.9914 28.1842 59.719 25.3773 63.2063 25.3773C65.0892 25.3773 66.4612 26.1182 67.4795 27.0647L69.1561 25.3936C67.7415 24.0424 65.8587 23.0078 63.2194 23.0078C58.4354 23.0078 54.4209 26.8917 54.4209 31.6471C54.4209 36.4155 58.4321 40.2863 63.2194 40.2863C65.803 40.2863 67.7415 39.4443 69.274 37.8581C70.8359 36.3012 71.3303 34.1047 71.3303 32.3325C71.3303 31.7809 71.2878 31.2848 71.1994 30.8638H63.19C63.1932 30.8605 63.1932 30.8899 63.1932 30.8899ZM122.687 32.7241C122.219 31.4741 120.805 29.1764 117.903 29.1764C115.028 29.1764 112.638 31.4317 112.638 34.7444C112.638 37.8711 115.002 40.3124 118.182 40.3124C120.736 40.3124 122.222 38.7556 122.835 37.8417L120.939 36.5754C120.31 37.5056 119.436 38.1159 118.195 38.1159C116.941 38.1159 116.063 37.548 115.48 36.4285L122.949 33.3442C122.949 33.3475 122.687 32.7241 122.687 32.7241ZM115.071 34.5845C115.012 32.4336 116.747 31.3403 117.988 31.3403C118.968 31.3403 119.783 31.8201 120.061 32.5185L115.071 34.5845ZM109.003 39.9795H111.456V23.6214H109.003V39.9795ZM104.976 30.4264H104.887C104.334 29.7704 103.283 29.1764 101.94 29.1764C99.1536 29.1764 96.5864 31.621 96.5864 34.7607C96.5864 37.8874 99.1405 40.3026 101.94 40.3026C103.266 40.3026 104.334 39.7054 104.887 39.0363H104.976V39.8359C104.976 41.9606 103.836 43.1062 101.999 43.1062C100.496 43.1062 99.5629 42.0292 99.1831 41.1284L97.0514 42.0161C97.6637 43.4848 99.2977 45.3028 101.996 45.3028C104.871 45.3028 107.307 43.6154 107.307 39.4998V29.5093H104.989V30.4264C104.992 30.4264 104.976 30.4264 104.976 30.4264ZM102.16 38.1192C100.467 38.1192 99.0521 36.7092 99.0521 34.7607C99.0521 32.7959 100.467 31.3729 102.16 31.3729C103.836 31.3729 105.136 32.8122 105.136 34.7607C105.152 36.7092 103.839 38.1192 102.16 38.1192ZM134.171 23.6214H128.306V39.9795H130.759V33.7849H134.174C136.889 33.7849 139.557 31.8233 139.557 28.7097C139.557 25.596 136.899 23.6214 134.171 23.6214ZM134.243 31.5002H130.756V25.8865H134.243C136.08 25.8865 137.118 27.3976 137.118 28.6933C137.118 29.976 136.067 31.5002 134.243 31.5002ZM149.387 29.1601C147.606 29.1601 145.769 29.9466 145.01 31.6601L147.184 32.5609C147.652 31.6601 148.51 31.3533 149.417 31.3533C150.687 31.3533 151.971 32.1105 152.001 33.4617V33.6347C151.562 33.3867 150.599 33.0081 149.446 33.0081C147.099 33.0081 144.718 34.2875 144.718 36.6864C144.718 38.8829 146.643 40.2929 148.788 40.2929C150.435 40.2929 151.342 39.552 151.909 38.6936H151.997V39.9599H154.361V33.6935C154.361 30.7756 152.187 29.1601 149.387 29.1601ZM149.08 38.1192C148.277 38.1192 147.154 37.7275 147.154 36.7223C147.154 35.4559 148.556 34.9761 149.751 34.9761C150.832 34.9761 151.342 35.2079 151.984 35.5277C151.807 36.9964 150.563 38.1061 149.08 38.1192ZM162.986 29.5093L160.17 36.6048H160.082L157.164 29.5093H154.525L158.903 39.4279L156.408 44.9405H158.962L165.698 29.5093H162.986ZM140.91 39.9795H143.362V23.6214H140.91V39.9795Z"
        fill="#FAFAFA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.2008 10.5754C13.821 10.9834 13.6016 11.6068 13.6016 12.4227V41.3628C13.6016 42.1787 13.821 42.8021 14.2139 43.1938L14.3154 43.2819L30.583 27.0674V26.7051L14.3023 10.4873L14.2008 10.5754Z"
        fill="url(#paint0_linear_1351_4609)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.9952 32.4888L30.5693 27.0806V26.702L35.9952 21.2939L36.1131 21.3657L42.5311 25.0016C44.3681 26.033 44.3681 27.7367 42.5311 28.7811L36.1131 32.4169L35.9952 32.4888Z"
        fill="url(#paint1_linear_1351_4609)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M36.113 32.4172L30.5693 26.8916L14.2002 43.2073C14.7994 43.847 15.8047 43.9188 16.9278 43.2954L36.113 32.4172Z"
        fill="url(#paint2_linear_1351_4609)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M36.113 21.3658L16.9278 10.5039C15.8047 9.8642 14.7962 9.95232 14.2002 10.592L30.5693 26.8914L36.113 21.3658Z"
        fill="url(#paint3_linear_1351_4609)"
      />
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.9948 32.2998L16.9405 43.0899C15.8763 43.7002 14.9267 43.6578 14.3144 43.1029L14.2129 43.2041L14.3144 43.2922C14.9267 43.8438 15.8763 43.8895 16.9405 43.2792L36.1258 32.4173L35.9948 32.2998Z"
        fill="#131313"
      />
      <path
        opacity="0.12"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.5317 28.592L35.9795 32.2997L36.0974 32.4172L42.5153 28.7813C43.4355 28.2591 43.8874 27.5737 43.8874 26.8916C43.8317 27.5182 43.3634 28.1123 42.5317 28.592Z"
        fill="#131313"
      />
      <path
        opacity="0.25"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.9284 10.693L42.5316 25.1908C43.3633 25.6575 43.8316 26.2679 43.9036 26.8912C43.9036 26.2091 43.4517 25.5237 42.5316 25.0015L16.9284 10.5037C15.0915 9.45607 13.6016 10.3308 13.6016 12.4229V12.6122C13.6016 10.5168 15.0915 9.65842 16.9284 10.693Z"
        fill="#FAFAFA"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1351_4609"
        x1="29.1238"
        y1="12.1105"
        x2="3.07725"
        y2="19.0734"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A0FF" />
        <stop offset="0.00657" stop-color="#00A1FF" />
        <stop offset="0.2601" stop-color="#00BEFF" />
        <stop offset="0.5122" stop-color="#00D2FF" />
        <stop offset="0.7604" stop-color="#00DFFF" />
        <stop offset="1" stop-color="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1351_4609"
        x1="44.9267"
        y1="26.8914"
        x2="13.1544"
        y2="26.8914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE000" />
        <stop offset="0.4087" stop-color="#FFBD00" />
        <stop offset="0.7754" stop-color="#FFA500" />
        <stop offset="1" stop-color="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1351_4609"
        x1="33.0986"
        y1="29.8983"
        x2="12.2804"
        y2="65.0519"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF3A44" />
        <stop offset="1" stop-color="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1351_4609"
        x1="10.0783"
        y1="0.94979"
        x2="19.3661"
        y2="16.6499"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#32A071" />
        <stop offset="0.0685" stop-color="#2DA771" />
        <stop offset="0.4762" stop-color="#15CF74" />
        <stop offset="0.8009" stop-color="#06E775" />
        <stop offset="1" stop-color="#00F076" />
      </linearGradient>
      <clipPath id="clip0_1351_4609">
        <rect
          width="177.994"
          height="52.3512"
          fill="white"
          transform="translate(0.5 0.71582)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
